import React from 'react';
import { Box, themes } from '@digitools/honest-react';
import { useTranslation } from 'react-i18next';
import useExperience from '../../../../../hooks/useExperience';
import titleCase from 'status/utilities/titleCase';
import formatPhone from 'status/utilities/formatPhone';
import useAuthentication from '../../../../../hooks/useAuthentication';
import useTealium from '../../../../../hooks/useTealium';
import useTranslate from 'src/hooks/useTranslate';
import { Experience } from 'src/types/Experience';
export const CASE_MANAGER_ERROR_TEXT = {
    english: 'Unable to load case manager',
    spanish: 'No se puede cargar el administrador de casos',
};
export const OFFICE_NOT_FOUND_TEXT = {
    english: 'Office information unavailable',
    spanish: 'Información de la oficina no disponible',
};
const CaseManager = ({ caseManager, claimNum, employeeName, prodType }) => {
    const { t: oldTranslate } = useTranslation();
    const { t } = useTranslate();
    const { user } = useAuthentication();
    const { trackEvent } = useTealium();
    const { experience } = useExperience();
    const customerId = user.customerId;
    const isEmployer = experience === Experience.EMPLOYER;
    /** Email formatting and logic  */
    const subject = `${employeeName + (employeeName && ' ')}%23${claimNum}`;
    /** prevent any non lfg emails */
    const isLfgEmail = (caseManager.emailAddr && caseManager.emailAddr.toLowerCase().includes('@lfg.com'));
    return (<>
      <Box type='header' style={{ border: `1px solid ${themes.lincoln.palette.grayLighter}` }}>
        {oldTranslate('caseManagerText')}
      </Box>
      <Box style={{
            wordWrap: 'break-word',
            marginBottom: '1rem',
            border: `1px solid ${themes.lincoln.palette.grayLighter}`,
        }}>
          {caseManager.cntcFirstName &&
            <small data-private={true} className='d-block' data-testid='name'>
              {titleCase(caseManager.cntcFirstName)} {titleCase(caseManager.cntcLastName)}
            </small>}
          <small className='d-block'>{caseManager.officeName}</small>
          <small className='d-block'>{caseManager.address}</small>
            <small className='d-block'>
              {`${caseManager.city},`} {caseManager.state} {caseManager.zip}
            </small>
          <small className='d-block'>
            <strong>{oldTranslate('phoneText')}: </strong> {formatPhone(caseManager.phone)}
            {(caseManager.phone) && caseManager?.phoneExt && ` ext. ${caseManager.phoneExt}`}
          </small>
          {(user?.customerInContext?.smallMid || isEmployer) && caseManager.emailAddr && (<small data-private={true} className='d-block'>
              <strong>Email: </strong>
              {isLfgEmail &&
                <a id='email-address' href={`mailto:${caseManager.emailAddr}?subject=${subject}`}>
                  {' '}
                  {caseManager.emailAddr}
                </a>}
            </small>)}
            {caseManager.fax &&
            <small className='d-block'>
                <strong>{oldTranslate('faxText')}: </strong> {formatPhone(caseManager.fax)}
              </small>}        
      </Box>
    </>);
};
export default CaseManager;
